import React, { useState, Fragment, useEffect } from 'react';
import { Card, Col, Input, Row, Space, Spin, Table, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { fetchQryData } from '../../../../api';
import { crawl } from '../../../../api/util';
import { useQuery } from '@tanstack/react-query';
import { notRelCci } from '../../../../api/query-key';
import { newApps, cardCss, tabPageCss } from './columns';
const { Text } = Typography;

const CatChange = (props) => {
    const releaseVersion = props.rel ? String(props.rel) : null;

    const { data: rawData, isLoading } = useQuery({
        queryKey: notRelCci.notify_rel_top_cat_ver(releaseVersion),
        queryFn: ({ signal }) =>
            fetchQryData(
                { type: 'fetch', qry: 'fetRelTopCatChanges', firstVal: releaseVersion },
                signal
            ),
        staleTime: Infinity,
        enabled: !!releaseVersion && !props.loader,
    });

    const tableData = React.useMemo(() => {
        if (!rawData) return [];
        return rawData.map((x, i) => ({ ...x, id: i }));
    }, [rawData]);

    const load = isLoading || props.loader;

    return (
        <div>
            <Row style={{ margin: '5px', padding: '1px' }}>
                <Col className="gutter-row" span={23}>
                    {!load ? (
                        <FetchTabSearch
                            submit={props.submit}
                            usrRel={props.usrRel}
                            data={tableData}
                            col={newApps}
                            setLiveMenu={props.setLiveMenu}
                        />
                    ) : (
                        <Card loading style={{ width: '100%', minHeight: '80vh' }}></Card>
                    )}
                </Col>
            </Row>
        </div>
    );
};

const FetchTabSearch = (props) => {
    const [searchVal, setSearchVal] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [origData, setOrigData] = useState([]);
    const [searchIndex, setSearchIndex] = useState([]);

    useEffect(() => {
        if (props.setLiveMenu) {
            props.setLiveMenu({ release: false, topMenu: 'R', botMenu: '2' });
        }
        const rows = props.data || [];
        setOrigData(rows);
        setFilteredData(rows);
        setSearchIndex(rows.map((user) => ({ allValues: crawl(user).toString() })));
    }, [props.data]);

    useEffect(() => {
        if (searchVal) {
            const reqData = searchIndex.map((user, index) => {
                if (user.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0)
                    return origData[index];
                return null;
            });
            setFilteredData(reqData.filter(Boolean));
        } else setFilteredData(origData);
    }, [searchVal, origData, searchIndex]);

    const releaseLabel = props.usrRel
        ? props.usrRel.split('snapshot_v')[1]?.split('_')[0]
        : '';

    return (
        <>
            <div>
                <Row gutter={16}>
                    <Col span={24}>
                        <Card
                            title={
                                <Row>
                                    <Col>
                                        <Space size="small">
                                            <Text>{'Release - ' + releaseLabel}</Text>
                                            <Text>
                                                Top App Category Changes (Subset of 'All App Categories', accounts
                                                for 90% of App traffic across Netskope customer base)
                                            </Text>
                                        </Space>
                                    </Col>
                                </Row>
                            }
                            size="small"
                            style={{ minHeight: '80vh' }}
                            bodyStyle={cardCss}
                            headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                            extra={
                                <Row>
                                    <Col span={21}>
                                        <Input
                                            onChange={(e) => setSearchVal(e.target.value)}
                                            prefix={<SearchOutlined className="site-form-item-icon" />}
                                            placeholder="Crawl Search"
                                            allowClear
                                        />
                                    </Col>
                                    <Col span={1}></Col>
                                    <Col className="gutter-row" span={2}>
                                        <div></div>
                                    </Col>
                                </Row>
                            }
                        >
                            <Fragment>
                                <Table
                                    rowKey="id"
                                    size="small"
                                    bordered
                                    scroll={{ x: 550, y: 900 }}
                                    style={{ margin: '2px' }}
                                    dataSource={filteredData}
                                    columns={props.col(filteredData.length)}
                                    loading={false}
                                    pagination={{
                                        pageSizeOptions: ['10', '30', '60', '100', '1000'],
                                        defaultPageSize: ['50'],
                                        showSizeChanger: true,
                                        style: tabPageCss,
                                    }}
                                />
                            </Fragment>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default CatChange;
